import { render, staticRenderFns } from "./AssetValueShareTooltip.vue?vue&type=template&id=3645a7c4&scoped=true&"
import script from "./AssetValueShareTooltip.vue?vue&type=script&lang=js&"
export * from "./AssetValueShareTooltip.vue?vue&type=script&lang=js&"
import style0 from "./AssetValueShareTooltip.vue?vue&type=style&index=0&id=3645a7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645a7c4",
  null
  
)

export default component.exports